import { GET_LIST, DETAIL } from "../../api/presence/detail";

const state = {
  list: [],
  detail: {},
  columns: [
    {
      label: "NIK",
      field: "nik",
    },
    {
      label: "Employee Name",
      field: "fullname",
    },
    {
      label: "Position",
      field: "position_name",
    },
    {
      label: "Department",
      field: "department_name",
    },
    {
      label: "Company",
      field: "company_name",
    },
    {
      label: "Man Hours",
      field: "man_hours",
    },
    {
      label: "Action",
      field: "action",
    },
  ],
};
const mutations = {
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_DETAIL: (state, payload) => {
    state.detail = payload;
  },
};
const actions = {
  GET_LIST: async ({ commit }, args) => {
    const resp = await GET_LIST();
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  DETAIL: async ({ commit }, args) => {
    const resp = await DETAIL(args.id);
    const data = resp.data.data;
    commit("SET_DETAIL", data);
  },
};
const getters = {
  list: (state) => state.list,
  detail: (state) => state.detail,
  columns: (state) => state.columns,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
